import { Box, MenuItem, Select, SelectChangeEvent, Slide, useScrollTrigger } from "@mui/material";
import { red } from "@mui/material/colors";
import { useDispatch, useSelector } from "react-redux";
import { LayoutMaxWidth, LayoutState } from "../Layout";
import { ui } from "../i18n";
import { changeLang } from "../state/Language";
import { RootState } from "../store";
import MainNavigationItem from "./MainNavigationItem";

export default function MainNavigationDesktop(params: {layoutState: LayoutState}) {
    // Setup scroll trigger
    const trigger = useScrollTrigger({ disableHysteresis: false, threshold: 100 });

    // Determine UI language
    const lang = useSelector((state: RootState) => state.language.value);

    // Handle language change
    const dispatch = useDispatch();
    const handleChange = (event: SelectChangeEvent) => {
        dispatch(changeLang(event.target.value as string));
        window.krlang = event.target.value;
    };

    return (
        <Slide appear={false} direction="down" in={!trigger}>
            <Box sx={{ bgcolor: "kr.main", paddingBottom: "1vH", position: "fixed", top: "190px", zIndex: 50, width: LayoutMaxWidth, paddingRight: params.layoutState.MainNavPaddingRight() }}>
                <MainNavigationItem name={ui[lang].MainNavigationItem.about} path="about" />
                <MainNavigationItem name={ui[lang].MainNavigationItem.artist} path="artist" />
                <MainNavigationItem name={ui[lang].MainNavigationItem.art} path="art" />
                <MainNavigationItem name={ui[lang].MainNavigationItem.galleryall} path="gallery/all" />
                <MainNavigationItem name={ui[lang].MainNavigationItem.booksall} path="books" />
                <MainNavigationItem name={ui[lang].MainNavigationItem.virtualtour} path="virtualtour" />
                <MainNavigationItem name={ui[lang].MainNavigationItem.visit} path="visit" />

                <Select sx={{ color: red }} variant="standard"
                    value={lang}
                    disableUnderline
                    onChange={handleChange}>
                    <MenuItem sx={{ color: red }} value={"de"}>DE</MenuItem>
                    <MenuItem value={"en"}>EN</MenuItem>
                </Select>

            </Box>
        </Slide>
    );
}